module.exports = __webpack_public_path__ + "static/media/MailChimpLogo.3a23c631.png";